<div class="outer">
    <div class="wrapper">
        <div class="header">
            {{title}}
            <button mat-dialog-close class="close-btn" (click)="closeDialog()"
                matTooltip="{{'businessTexts.close' | translate}}">
                <cqes-icon icon="close" class="close-icon"></cqes-icon>
            </button>
        </div>
        <div class="content">
            Document: <strong>{{data.file.name}}</strong>
            <div [formGroup]="signTypeForm">
                <div class="row">
                    <!-- format -->
                    <mat-form-field class="col-4 offset-1 line">
                        <mat-label>{{'signingTexts.signFormat' | translate}}</mat-label>
                        <mat-select placeholder="{{texts.signFormat}}" formControlName="signFormat" required
                            (selectionChange)="setInitialTypes($event)">
                            <mat-option *ngFor="let item of values.signFormat" [value]="item.value">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>

                        <cqes-icon icon="info" matSuffix class="info-icon-tool"
                            matTooltip="{{'signingTexts.info.cades' | translate}}&#13;{{'signingTexts.info.pades' | translate}}&#13;{{'signingTexts.info.xades' | translate}}">
                        </cqes-icon>
                    </mat-form-field>
                    <!-- sign level -->
                    <mat-form-field class="col-4 offset-2 line">
                        <mat-label> {{'signingTexts.signLevel' | translate}}</mat-label>
                        <mat-select placeholder="{{texts.signLevel}}" formControlName="signLevel" required>
                            <mat-option *ngFor="let item of values.signLevel" [value]="item.value">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                        <cqes-icon icon="info" matSuffix class="info-icon-tool"
                            matTooltip="{{'signingTexts.info.levelInfo' | translate}}">
                        </cqes-icon>
                    </mat-form-field>
                </div>

                <div class="row">
                    <!-- sign type -->
                    <mat-form-field class="col-4 offset-1 line">
                        <cqes-icon icon="info" matSuffix class="info-icon-tool"
                            matTooltip="{{'signingTexts.info.typeInfo' | translate}}">
                        </cqes-icon>
                        <mat-label>{{'signingTexts.signType' | translate}}</mat-label>
                        <mat-select placeholder="{{texts.signType}}" formControlName="signType" required>
                            <mat-option *ngFor="let item of values.signType" [value]="item.value">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- hash algo -->
                    <mat-form-field class="col-4 offset-2 line">
                        <cqes-icon icon="info" matSuffix class="info-icon-tool"
                            matTooltip="{{'signingTexts.info.hashInfo' | translate}}">
                        </cqes-icon>
                        <mat-label>{{'signingTexts.signHashAlg' | translate}}</mat-label>
                        <mat-select placeholder="{{texts.signHashAlg}}" formControlName="signHashAlg" required>
                            <mat-option *ngFor="let item of values.signHashAlg" [value]="item.value">
                                {{ item.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="button-container">
            <button mat-raised-button color="primary" (click)="onSave()" [disabled]="false">{{'settingsList.common.save'
                | translate}}</button>
            <button mat-raised-button mat-dialog-close color="primary" (click)="closeDialog()">
                {{'settingsList.common.cancel' | translate}}
            </button>
        </div>

    </div>

</div>
